var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTemperatureWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5.33333,
    fill: "#F8F025"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1947 27.7793C16.5278 28.426 19.4131 25.8889 19.4131 22.6553C19.4131 20.9639 18.5674 19.4217 17.274 18.4765V7.08434C17.274 5.39293 15.9308 4 14.1896 4C12.4982 4 11.1053 5.39293 11.1053 7.08434V18.4765C9.56311 19.6207 8.66766 21.5609 9.11539 23.7498C9.51337 25.7397 11.155 27.3813 13.1947 27.7793ZM11.752 19.4217L12.1997 19.0735V7.13409C12.1997 6.03965 13.0952 5.19394 14.1399 5.19394C15.2343 5.19394 16.1298 6.08939 16.1298 7.13409V19.0735L16.5775 19.4217C17.6222 20.1679 18.2192 21.4116 18.2192 22.7051C18.2192 23.7995 17.7715 24.8442 17.0252 25.5904C16.2293 26.3366 15.2343 26.7844 14.1399 26.7844C12.1002 26.7844 10.5083 25.3417 10.1601 23.5508C9.91135 21.9091 10.5083 20.3172 11.752 19.4217Z",
    fill: "#343434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1897 25.5903C14.9857 25.5903 15.7319 25.2918 16.2791 24.7446C16.8264 24.1974 17.1248 23.4511 17.1248 22.6552C17.1248 20.6653 15.4334 20.0186 14.9857 19.6206V11.2133H13.344V19.6206C12.9958 20.0186 10.8069 20.8145 11.3044 23.2522C11.5531 24.5456 12.6973 25.5903 14.1897 25.5903Z",
    fill: "#343434"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.403 7.38269H18.5674V8.52688H21.403C21.7015 8.52688 21.9502 8.27815 21.9502 7.97966C22 7.63143 21.7512 7.38269 21.403 7.38269Z",
    fill: "#343434"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8559 10.9647C20.8559 10.6662 20.6072 10.4175 20.3087 10.4175H18.6173V11.5617H20.3087C20.6072 11.5119 20.8559 11.2632 20.8559 10.9647Z",
    fill: "#343434"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 13.9493C22.0001 13.6508 21.7514 13.402 21.4529 13.402H18.6173V14.5462H21.4529C21.7514 14.5462 22.0001 14.2477 22.0001 13.9493Z",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTemperatureWarning);
export default __webpack_public_path__ + "static/media/icon_temperature_warning.cd71b629feda44442485c6baf6434e0e.svg";
export { ForwardRef as ReactComponent };